import React, { Component } from 'react';
import AsideNavbar from '../components/navbars/AsideNavbar';
import Navbars from '../components/navbars/Navbars';

import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";

import CBSEChapterDetailsSection from '../foundation/components/cbse_foundation/cbseChapterDestailsSection';
import { ShimmerList } from '../components/preloader/Shimmer';

class CBSEChapterDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            toggled:
                isMobile === true && Cookies.get("institution_id") == 30
                    ? "wrapper"
                    : Cookies.get("toggle"),

            loading: true,
            chapterData: null
        };
    }

    componentDidMount() {

        // ⭐ UPDATED MOCK API — matches REAL backend structure
        const mockAPI = [
            {
                previousPapers: [
                    { id: 1, title: "2021 Exam Paper" },
                    { id: 2, title: "2022 Exam Paper" }
                ],

                // PDF links instead of array
                shortNotes: "https://rizee.in/eamcet_files/short_notes/functions_035.pdf",

                revisionalMaterial: "https://rizee.in/eamcet_files/cbse/Race_solutions_Basic_Geometrical_Ideas_N.pdf",

                // Videos have NO titles
                videos: [
                    { video_url: "https://www.youtube.com/embed/xI94e5poLNU" },
                    { video_url: "https://www.youtube.com/embed/5K8mnF618bg" }
                ],
                practise:[
                    {id:1, title:"Practice Set 1",exam_duration_min:45, is_completed:false},
                                        {id:2, title:"Practice Set 2",exam_duration_min:45, is_completed:true},
                ]
            }
        ];

        setTimeout(() => {
            this.setState({
                chapterData: mockAPI[0],
                loading: false
            });
        }, 500);
    }

    menuToggler = () => {
        const toggled = this.state.toggled;
        const newState = toggled === "wrapper" ? "wrapper sidebar-enable" : "wrapper";

        this.setState({ toggled: newState });
        Cookies.set("toggle", newState);
    };

    render() {
        if (Cookies.get("studenttoken") === undefined)
            this.props.history.push("/student/login");

        const { classId, subjectId, chapterId, tab } = this.props.match.params;

        return (
            <div className={this.state.toggled}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>

                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />

                    <div className="content-wrapper">

                        {this.state.loading ? (
                            <div className="text-center mt-5">
                                <ShimmerList />
                            </div>
                        ) : (
                            <CBSEChapterDetailsSection
                                chapterData={this.state.chapterData}

                                classId={classId}
                                subjectId={subjectId}
                                chapterId={chapterId}
                                tab={tab}

                                subjectName={this.props.location.state?.subjectName}
                                chapterName={this.props.location.state?.chapterName}
                            />
                        )}

                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(CBSEChapterDetails);
